import { schema } from "normalizr";

export const searchPreviewSchema = new schema.Entity("searchPreviews");